import { render, staticRenderFns } from "./ProjectsOverviewItem.vue?vue&type=template&id=44bf58a0&scoped=true&"
import script from "./ProjectsOverviewItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsOverviewItem.vue?vue&type=style&index=0&id=44bf58a0&scoped=true&lang=css&"
import style1 from "./ProjectsOverviewItem.vue?vue&type=style&index=1&id=44bf58a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bf58a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bf58a0')) {
      api.createRecord('44bf58a0', component.options)
    } else {
      api.reload('44bf58a0', component.options)
    }
    module.hot.accept("./ProjectsOverviewItem.vue?vue&type=template&id=44bf58a0&scoped=true&", function () {
      api.rerender('44bf58a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsOverviewItem.vue"
export default component.exports